export const ROOT = '/' as const;
export const MAIN = `${ROOT}:chart` as const;
